import { Box, Icon, Spacer, Text, TextInputNew } from '@jfs/ui-new'
import { useState } from 'react'
import { MidFilterItem } from './MidFilterItem'
import { filterTypes } from './types'

export const MidSearchFilter = ({ subMids, checkSelected, updateFilters }: any) => {
  const [searchString, setSearchString] = useState('')
  const [filterData, setFilterData] = useState<any>(subMids)
  const handleSearch = (val: string) => {
    setSearchString(val)
    const filterKeys = Object.values(subMids)
    const subMidData = filterKeys.filter((item: any) => item !== 'All')
    const retData: any = {}
    subMidData?.map((item: any) => {
      if (
        item?.mid?.toLowerCase()?.includes(val?.toLowerCase()) ||
        item?.businessName?.toLowerCase()?.includes(val?.toLowerCase())
      ) {
        retData[item.mid] = item
      }
    })
    setFilterData(retData)
  }
  return (
    <Box ph={16}>
      <Text title={'Account'} fontFamily={'jiotype-medium'} color={'BLACK_21'} fontSize={18} lineHeight={20} />
      <Spacer size={24} />
      <Text
        title={'Merchant Name/Store'}
        fontFamily={'jiotype-medium'}
        color={'BLACK_21'}
        fontSize={14}
        lineHeight={20}
      />
      <Spacer size={24} />
      <Box borderRadius={4} borderColor={'DISABLED_GREY'} borderWidth={1} p={16} maxHeight={480} w={400}>
        <TextInputNew
          borderRadius={4}
          borderColor={'DISABLED_GREY'}
          focusBorderColor={'DISABLED_GREY'}
          padding={8}
          value={searchString}
          onChange={handleSearch}
          placeholder={'Search for StoreName, MID'}
          placeholderTextColor={'BLACK_75'}
          fontSize={12}
          leftComponent={<Icon id={'SEARCH'} color={'BLACK_75'} />}
        />
        <MidFilterItem
          mode={filterTypes.mid}
          updateFilters={updateFilters}
          checkSelected={checkSelected}
          filterData={{ mid: filterData }}
        />
      </Box>
      <Spacer size={16} />
    </Box>
  )
}
